import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

import { Box, styled } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LensBorderLeft = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  left: 0;\n  bottom: 0;\n  position: fixed;\n  height: 100%;\n  width: 4px;\n  background: ", ";\n  z-index: ", ";\n"])), function (p) {
  return p.theme.palette.accent.main;
}, [function (p) {
  return p.theme.zIndex.aboveDrawer;
}]);
var LensBorderRight = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  right: 0;\n  bottom: 0;\n  position: fixed;\n  height: 100%;\n  width: 4px;\n  background: ", ";\n  z-index: ", ";\n"])), function (p) {
  return p.theme.palette.accent.main;
}, [function (p) {
  return p.theme.zIndex.aboveDrawer;
}]);
var LensBorderBottom = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  bottom: 0;\n  position: fixed;\n  height: 4px;\n  width: 100%;\n  background: ", ";\n  z-index: ", ";\n"])), function (p) {
  return p.theme.palette.accent.main;
}, [function (p) {
  return p.theme.zIndex.aboveDrawer;
}]);

var LensBorder = function LensBorder() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LensBorderLeft, {
      "data-element": "LensBorderLeft",
      "data-component": "LensBorder",
      "data-source-file": "lens-border.tsx"
    }), /*#__PURE__*/_jsx(LensBorderRight, {
      "data-element": "LensBorderRight",
      "data-source-file": "lens-border.tsx"
    }), /*#__PURE__*/_jsx(LensBorderBottom, {
      "data-element": "LensBorderBottom",
      "data-source-file": "lens-border.tsx"
    })]
  });
};

export default LensBorder;